import { NO_REPORT, TASK_SHOW } from '../../config/url';
import { handleFormatRes, request, RespError } from '../../utils';
import { reportTaskShowRes } from './report';
/** 虚拟资格类型 */
export var TaskRequiredType;
(function (TaskRequiredType) {
    /** 1-累计次数的虚拟资格 */
    TaskRequiredType["count"] = "1";
    /** 2-累计金额的虚拟资格 */
    TaskRequiredType["amount"] = "2";
})(TaskRequiredType || (TaskRequiredType = {}));
/** 任务领取限制类型 */
export var TaskGetType;
(function (TaskGetType) {
    /**  1-任务有效期内，算同一个周期 */
    TaskGetType["allPeriod"] = "1";
    /** 2-每日一个周期 */
    TaskGetType["perDay"] = "2";
    /** 3-每个自然周(周一至周日)一个周期 */
    TaskGetType["perWeek"] = "3";
    /** 4-每个自然月一个周期 */
    TaskGetType["perMonth"] = "4";
})(TaskGetType || (TaskGetType = {}));
/** 任务类型 */
export var TaskType;
(function (TaskType) {
    /** basic–基础任务 */
    TaskType["basic"] = "basic";
    /** spec-专属任务 */
    TaskType["spec"] = "spec";
})(TaskType || (TaskType = {}));
/** 任务状态:0-未领取任务;1-已领取、未完成;2-已完成、待领奖;3-领奖中;4-已领奖;5-领奖失败; */
export var TaskStatus;
(function (TaskStatus) {
    /** 0-未领取任务 */
    TaskStatus[TaskStatus["notReceiveTask"] = 0] = "notReceiveTask";
    /** 1-已领取、未完成 */
    TaskStatus[TaskStatus["notCompleteTask"] = 1] = "notCompleteTask";
    /** 2-已完成、待领奖 */
    TaskStatus[TaskStatus["notGetPrize"] = 2] = "notGetPrize";
    /** 3-领奖中 */
    TaskStatus[TaskStatus["gettingPrize"] = 3] = "gettingPrize";
    /** 4-已领奖 */
    TaskStatus[TaskStatus["gotPrize"] = 4] = "gotPrize";
    /** 5-领奖失败 */
    TaskStatus[TaskStatus["failGetPrize"] = 5] = "failGetPrize";
})(TaskStatus || (TaskStatus = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = [
    'maxTimes',
    'status',
    'requiredCount',
    'totalCnt',
    'usedCnt',
    'basictaskNum',
    'spectaskNum',
    'taskTotalCnt',
    'taskSendCnt',
];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['completeTime', 'sysTime', 'curtaskStartTime', 'curtaskEndTime', 'taskStartTime', 'taskEndTime'];
/**
 * 任务查询接口
 *
 * 1.查询范围： 单活动 + 单周期;2.输出以上查询范围内用户任务完成状态以及活动中可获得的奖品信息
 *
 * 接口地址：`/app/task/prom_batch_task_show_v2.cgi`
 *
 * @param actIdList 活动ID数组
 * @returns
 */
export async function taskShow({ actIdList }) {
    // 参数格式化
    const params = {
        t: new Date().getTime(),
        actid_group: actIdList.join('|'),
    };
    try {
        // 接口请求
        const result = await request.get(`${TASK_SHOW}?${NO_REPORT}`, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                // 先处理task_desc字段
                actIdList.forEach((actId) => {
                    const actTaskList = result[actId] || [];
                    actTaskList.forEach((task) => {
                        Object.assign(task, {
                            taskDesc: JSON.parse(atob(task.task_desc) || '{}'),
                        });
                    });
                });
                // 转换动态key格式
                const { retcode, retmsg, sys_time, task_info, task_quota } = result;
                const transformedResult = { retcode, retmsg, sys_time, task_info, task_quota };
                task_info.forEach((item) => {
                    const actId = item.act_id;
                    const actTaskList = result[actId] || [];
                    Object.assign(item, {
                        basicTaskList: getTaskListWithQuota({ taskQuotaList: task_quota, taskList: actTaskList.filter((item) => item.task_type === 'basic') }),
                        specTaskList: getTaskListWithQuota({ taskQuotaList: task_quota, taskList: actTaskList.filter((item) => item.task_type === 'spec') }),
                    });
                });
                // 转换下划线
                const res = handleFormatRes({
                    result: transformedResult,
                    needParseIntKey,
                    needParseDateKey,
                    transformer: (data) => {
                        const { retcode, retmsg, sysTime, taskInfo } = data;
                        return { retcode, retmsg, sysTime, actTaskInfoList: taskInfo };
                    },
                });
                // 正常上报
                reportTaskShowRes(res, params);
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        // 异常上报
        reportTaskShowRes(error, params);
        throw error;
    }
}
/**
 * 根据 taskName和taskId，从task_quota数组中返回对应任务的 taskTotalCnt和taskSendCnt
 */
const getTaskListWithQuota = ({ taskQuotaList = [], taskList = [] }) => {
    const taskListWithQuota = taskList.map((task = {}) => {
        const { task_name, task_id } = task;
        const targetQuota = taskQuotaList.find(quota => quota.task_id === task_id && quota.task_name === task_name);
        // TODO: 如果用undefined, 转number的时候会变成NaN
        const { task_total_cnt, task_send_cnt } = targetQuota || {};
        return Object.assign(Object.assign({}, task), { task_total_cnt, task_send_cnt });
    });
    return taskListWithQuota;
};
